































import { Component, Vue } from 'vue-property-decorator'
// @ts-ignore
import ClickOutside from 'vue-click-outside'
import Notification from '@/components/UI/header/NotificationCenter/Notification.vue'
import API from '@/services/API'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'
@Component({
    components: { Notification, BaseIcon },
    directives: {
        ClickOutside,
    },
})
export default class HeaderActionNotification extends Vue {
    showNotifications = false
    notifications: any[] = []
    loading = { notifications: false }

    get newNotifications() {
        if (!this.notifications) {
            return 0
        }

        const unreadNotifications = this.notifications.filter(notif => !notif.displayed_at)

        return unreadNotifications.length || 0
    }

    mounted() {
        this.requestNotifications()
    }

    toggleNotificationCenter() {
        this.showNotifications = !this.showNotifications
    }

    hideNotificationCenter() {
        if (this.showNotifications) {
            this.showNotifications = false
        }
    }

    async requestNotifications() {
        try {
            this.loading.notifications = true
            const result = await API.getNotifications()
            this.notifications = result.items
        } catch (e) {
            this.notifications = []
        } finally {
            this.loading.notifications = false
        }
    }
}
